import { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <section className="bg-dark" style={{width: "100%", height: "40px"}}>
            </section>
        );
    }
}

export default Footer;